var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUser = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 15.3333V13.9999C13.6667 13.2927 13.3857 12.6144 12.8856 12.1143C12.3855 11.6142 11.7072 11.3333 11 11.3333H5.66667C4.95942 11.3333 4.28115 11.6142 3.78105 12.1143C3.28095 12.6144 3 13.2927 3 13.9999V15.3333",
    stroke: "#7D86A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 7.33333C9.80593 7.33333 10.9998 6.13943 10.9998 4.66667C10.9998 3.19391 9.80593 2 8.33317 2C6.86041 2 5.6665 3.19391 5.6665 4.66667C5.6665 6.13943 6.86041 7.33333 8.33317 7.33333Z",
    stroke: "#7D86A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.b77a4289.svg";
export { ForwardRef as ReactComponent };